export default "__VITE_ASSET__CXnbNoWY__"